import monolith from "../utils/fetch/fetches";

/**
 * @return True if this email is available, and false otherwise.
 */
export const isEmailAvailable = async (email: string): Promise<boolean> => {
  const response = await monolith()(`/hib/users?email=${encodeURIComponent(email)}`);
  const body = await response.json();
  return !body.users?.[0];
};
